export enum UserDateFormat {
	DMY_DOT = 'dd-dot-mm-dot-yy',
	DMY_SLASH = 'dd-slash-mm-slash-yy',
	DMY_DASH = 'dd-hyphen-mm-hyphen-yy',
	MDY_SLASH = 'mm-slash-dd-slash-yy',
	MDY_DASH = 'mm-hyphen-dd-hyphen-yy',
	YMD_DATE = 'yy-hyphen-mm-hyphen-dd',
}
